import { Component, Vue } from 'vue-property-decorator';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import RefCardItem from '@/shared/cards/briefing/ref-card-item/ref-card-item.vue';

let tokenClient;
let access_token = null;

@Component({
  components: {
    'ref-item': RefCardItem,
    vueCustomScrollbar: vueCustomScrollbar,
  },
})
export default class GoogleSigninComponent extends Vue {
  beforeCreate() {
    // @ts-ignore
    tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: '282196142246-bmgl02ms6oohg6r2rslsvuui721se15e.apps.googleusercontent.com',
      scope: 'https://www.googleapis.com/auth/drive',
      callback: '', // defined later
    });
  }

  openGooglePopup() {
    tokenClient.callback = async resp => {
      if (resp.error !== undefined) {
        throw resp;
      }
      access_token = resp.access_token;
      console.log('inf = ', resp);
      const userInfo = await this.getUserInfo(access_token);
      console.log('User Info:', userInfo);
      this.$emit('access-token', access_token, userInfo);
    };

    if (access_token === null) {
      // Prompt the user to select a Google Account and ask for consent to share their data
      // when establishing a new session.
      tokenClient.requestAccessToken({ prompt: 'consent' });
    } else {
      // Skip display of account chooser and consent dialog for an existing session.
      tokenClient.requestAccessToken({ prompt: '' });
    }
  }

  async getUserInfo(token: string) {
    try {
      const response = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
        headers: { Authorization: `Bearer ${token}` },
      });
      return await response.json();
    } catch (error) {
      console.error('Error fetching user info:', error);
      return null;
    }
  }
}
